import { apiClient } from "../../../lib/axios";
import type {
    OnboardingQuestionsResponse,
    OnboardingResponsesRequest,
    OnboardingResponsesResponse,
} from "./types";

export interface SaveWhoopUserRequest {
    accessToken: string;
    refreshToken: string;
    expiresAt: string; // ISO timestamp
    profile: {
        id: string;
        firstName: string;
        lastName: string;
        email?: string;
        gender?: string;
        birthDate?: string;
    };
    device?: {
        id: string;
        model: string;
        serialNumber: string;
        firmwareVersion?: string;
    };
}

export interface SaveWhoopUserResponse {
    success: boolean;
    message?: string;
}

export interface SaveFitbitUserRequest {
    accessToken: string;
    refreshToken: string;
    tokenType?: string;
    scope?: string;
    expiresAt: string;
    profile: {
        id: string;
        firstName?: string;
        lastName?: string;
        email?: string;
    };
}

export interface SaveFitbitUserResponse {
    success: boolean;
    message?: string;
}

export const integrationApi = {
    getIntegrationProviders: async () => {
        const response = await apiClient.get("/integration");
        return response.data;
    },

    exchangeWhoopToken: async (
        code: string,
        redirect_uri: string,
        state?: string,
        code_verifier?: string
    ) => {
        const response = await apiClient.post("/integration/whoop/token", {
            code,
            redirect_uri,
            state,
            code_verifier,
        });
        return response.data;
    },

    saveWhoopUser: async (data: SaveWhoopUserRequest): Promise<SaveWhoopUserResponse> => {
        const response = await apiClient.post("/integration/whoop/user", data);
        return response.data;
    },

    exchangeFitbitToken: async (code: string, redirect_uri: string) => {
        const response = await apiClient.post("/integration/fitbit/token", { code, redirect_uri });
        return response.data;
    },

    saveFitbitUser: async (data: SaveFitbitUserRequest): Promise<SaveFitbitUserResponse> => {
        const response = await apiClient.post("/integration/fitbit/user", data);
        return response.data;
    },
};
